import React from 'react';

const CoverageSection = () => {
  const cities = [
    'Ahmedabad', 'Gandhinagar', 'Surat', 'Vadodara',
    'Mumbai', 'Pune', 'Bengaluru', 'Chennai',
    'Hyderabad', 'Delhi NCR', 'Jaipur', 'Kolkata'
  ];

  return (
    <section className="py-[40px] bg-surface-container-lowest" id="cities">
      <div className="max-w-[1400px] mx-auto px-[32px]">
        <div className="text-center mb-[40px]">
          <h2 className="font-headline text-[36px] font-extrabold tracking-tight text-on-surface">Serving 15+ Cities Across India</h2>
          <p className="text-on-surface-variant mt-[16px]">Expanding our footprint to ensure reliable corporate mobility everywhere your business goes.</p>
        </div>
        <div className="flex flex-wrap justify-center gap-[16px]">
          {cities.map((city, i) => (
            <span
              key={i}
              className="px-[24px] py-[12px] bg-white border border-outline-variant/30 rounded-full font-semibold text-on-surface-variant hover:border-primary hover:text-primary transition-all cursor-default"
            >
              {city}
            </span>
          ))}
        </div>
        <div className="text-center mt-[48px]">
          <p className="text-on-surface-variant text-[14px]">
            Don't see your city? <a className="text-primary font-bold hover:underline" href="#">Contact us</a> for custom fleet deployment in your region.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CoverageSection;


